// report type
export const DIALOGTYPE = 'Dialog';
export const LITYPE = 'LocationIntelligence';
export const AUDTYPE = 'AudienceOverview';
export const MEDIATYPE = 'MediaUsage';
export const CROSSTYPE = 'AudienceCrosstab';
export const BEHAVIOURTYPE = 'BehaviourDiscovery';
export const CROSSMEDIATYPE = 'CrossMedia';
export const LANDINGTYPE = 'Landing';
export const DEFINETYPE = 'Define';
export const CSVTYPE = 'CSV';
export const CRMTYPE = 'CRM';
export const VARIABLEMAPPINGTYPE = 'VariableMapping';
export const MMMTYPE = 'MMM';

// reach
export const MIN = 'min';
export const MAX = 'max';
export const PRICE = 'price';

// map
export const BRAMPTONBUSROUTES = 'Brampton Bus Routes';

// province
export const provinceMapping = {
  National: 'National',
  ON: 'Ontario',
  QC: 'Quebec',
  BC: 'British Columbia',
  AB: 'Alberta',
  MB: 'Manitoba',
  SK: 'Saskatchewan',
  NS: 'Nova Scotia',
  NB: 'New Brunswick',
  NL: 'Newfoundland and Labrador',
  PE: 'Prince Edward Island',
  NT: 'Northwest Territories',
  YT: 'Yukon',
  NU: 'Nunavut',
};

export const stateMapping = {
  National: 'National',
  AL: 'Alabama',
  AK: 'Alaska',
  AZ: 'Arizona',
  AR: 'Arkansas',
  CA: 'California',
  CO: 'Colorado',
  CT: 'Connecticut',
  DE: 'Delaware',
  FL: 'Florida',
  GA: 'Georgia',
  HI: 'Hawaii',
  ID: 'Idaho',
  IL: 'Illinois',
  IN: 'Indiana',
  IA: 'Iowa',
  KS: 'Kansas',
  KY: 'Kentucky',
  LA: 'Louisiana',
  ME: 'Maine',
  MD: 'Maryland',
  MA: 'Massachusetts',
  MI: 'Michigan',
  MN: 'Minnesota',
  MS: 'Mississippi',
  MO: 'Missouri',
  MT: 'Montana',
  NE: 'Nebraska',
  NV: 'Nevada',
  NH: 'New Hampshire',
  NJ: 'New Jersey',
  NM: 'New Mexico',
  NY: 'New York',
  NC: 'North Carolina',
  ND: 'North Dakota',
  OH: 'Ohio',
  OK: 'Oklahoma',
  OR: 'Oregon',
  PA: 'Pennsylvania',
  RI: 'Rhode Island',
  SC: 'South Carolina',
  SD: 'South Dakota',
  TN: 'Tennessee',
  TX: 'Texas',
  UT: 'Utah',
  VT: 'Vermont',
  VA: 'Virginia',
  WA: 'Washington',
  WV: 'West Virginia',
  WI: 'Wisconsin',
  WY: 'Wyoming',
};

// segment
export const segmentMapping = {
  cis: 'Common Industry Segments',
  pri: 'Environics',
  rog: 'Rogers Red Segments',
};

export const MenuProps = {
  anchorOrigin: {
    vertical: 'bottom',
    horizontal: 'left',
  },
  transformOrigin: {
    vertical: 'top',
    horizontal: 'left',
  },
  getContentAnchorEl: null,
};

// roles
export const R_ADMIN = 'admin';
export const R_OWNER = 'owner';
export const R_EDITOR = 'editor';
export const R_VIEWER = 'viewer';
